import React from 'react';

const DashboardButton = ({
    title,
    onClick,
    icon,
    className = '',
    disabled = false,
    isAdmin = false
}) => {
    const baseStyles = `
        group
        relative
        overflow-hidden
        rounded-2xl
        backdrop-blur-sm
        bg-white/80
        border
        border-red-100
        transition-all
        duration-300
        hover:scale-[1.02]
        hover:shadow-2xl
        ${isAdmin ? 'hover:border-red-300' : 'hover:border-red-300'}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${className}
    `;

    const gradientStyles = isAdmin
        ? "absolute inset-0 bg-gradient-to-br from-red-500/10 via-transparent to-red-300/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        : "absolute inset-0 bg-gradient-to-br from-red-500/10 via-transparent to-red-300/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300";

    const iconContainerStyles = isAdmin
        ? "flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-xl text-white shadow-lg transform group-hover:scale-110 transition-transform duration-300"
        : "flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-xl text-white shadow-lg transform group-hover:scale-110 transition-transform duration-300";

    const textStyles = isAdmin
        ? "text-center md:text-left text-base md:text-lg font-medium text-gray-800 group-hover:text-red-700 transition-colors duration-300"
        : "text-center md:text-left text-base md:text-lg font-medium text-gray-800 group-hover:text-red-700 transition-colors duration-300";

    return (
        <button
            onClick={disabled ? undefined : onClick}
            className={baseStyles}
            disabled={disabled}
        >
            <div className={gradientStyles} />
            <div className="relative p-4 md:p-6 flex flex-col md:flex-row items-center gap-3 md:gap-4">
                <div className={iconContainerStyles} style={{ background: 'linear-gradient(to bottom right, #cd212a, #a91b23)' }}>
                    {icon}
                </div>
                <span className={textStyles}>
                    {title}
                </span>
            </div>
        </button>
    );
};

export default DashboardButton;
